<template lang="pug">
  .c-exhibition.col-24
    .c-exhibition__item(v-for="(item, index) in exhibition" :key='index')
      .c-exhibition__item--image(:style="{backgroundImage:'url('+ item.url +')'}")
      .c-exhibition__item--content(:style="{backgroundColor: item.bgColor }")
        .c-exhibition__item--text
          .font-title-middle.fontBold(:style="{color: item.color }") {{ item.title }}
          p.font-section.l-margin-bottom-1em(:style="{color: item.contentColor }") {{ item.content }}
          q-btn.c-exhibition__item--btn(outline @click="openPopup(index)" :label="text.more" padding="3px 2.5em" :style="{ color: item.btnColor }")

    PopupPressalit(ref="popupPressalit" :content="popupValue")

</template>

<script>
  import PopupPressalit from '../popup/popupPressalit.vue'

  export default {
    name: 'pressalitList',
    props: ['content'],
    components: {
      PopupPressalit,
      'q-btn': Quasar.QBtn,
    },
    data(){
      return{
        text: {
          more: this.$t('common.more')
        },
        exhibition: [
          {url: require('@/assets/img/pressalit_1.jpg'), link:'', title: this.$t('pressalit.title_1'), content: this.$t('pressalit.content_1'), color: '#232323', contentColor:'#181818', bgColor: '#FAFAFA', btnColor: '#181818'},
          {url: require('@/assets/img/pressalit_2.jpg'), link:'', title: this.$t('pressalit.title_2'), content: this.$t('pressalit.content_2'), color: '#232323', contentColor:'#181818', bgColor: '#FFFFFF', btnColor: '#181818'},
          {url: require('@/assets/img/pressalit_3.jpg'), link:'', title: this.$t('pressalit.title_3'), content: this.$t('pressalit.content_3'), color: '#232323', contentColor:'#181818', bgColor: '#FAFAFA', btnColor: '#181818'},
          {url: require('@/assets/img/pressalit_4.jpg'), link:'', title: this.$t('pressalit.title_4'), content: this.$t('pressalit.content_4'), color: '#232323', contentColor:'#181818', bgColor: '#FFFFFF', btnColor: '#181818'}
        ],
        popupValue: {
          popup: false,
          index: 0
        }
      }
    },
    computed: {},
    methods: {
      openPopup(index){
        this.popupValue = {
          popup: true,
          index: index
        }
      },
    },
    created(){}
  }
</script>
